
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import HomeHeader from '@/views/Home/components/HomeHeader.vue';
import { useGetter, useAuthState } from '@/utils/store.util';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import jsCookie from 'js-cookie';
import { JAAS_LOGIN_URL } from '@/utils/login.util';

@Component({ components: { HomeHeader } })
export default class Home extends Vue {
  get isLoggedIn(): boolean {
    return useAuthState.call(this).isLoggedIn;
  }

  @Watch('isLoggedIn', { immediate: true })
  @isTruthy
  public onLoggedIn(value: boolean) {
    this.$router.push({
      name: 'redirection-handler'
    });
  }

  public mounted() {
    const jaasSID = jsCookie.get('jaas.sid');
    if (jaasSID !== undefined && !this.isLoggedIn) {
      window.location.href = JAAS_LOGIN_URL;
    }
  }
}
